import React from "react";
import PublicHeader from "components/Header/PublicHeader";
import AccessibilityToolbar from "components/AccessibilityToolbar/AccessibilityToolbar";

// Phase C.7.4D-R5 (§1 Forgot Password page composition): route-scoped, same pattern already used by
// PublicHeader.jsx's own isHomePath/isRegistrationPath/isCandidatePublicJourneyPath helpers. Applies a
// flex page-shell ONLY on /forgot-password (see themes.scss's `.ent-page-shell` rule) so the header
// stays at the top, the card centers in the remaining space, and the footer sits at the natural
// bottom — without touching `.loginPage`, which every other public page (Registration, Login, Reset
// Password) also renders through this same mount point.
function isForgotPasswordPath(pathname) {
    return pathname === "/forgot-password";
}

class PublicLayout extends React.Component{
    render(){
        const shellClass = typeof window !== "undefined" && isForgotPasswordPath(window.location.pathname)
            ? "ent-page-shell"
            : undefined;
        return (
        <div className={shellClass}>
            {/* Sprint 2.4B: previously no header rendered here at all — see PublicHeader.jsx */}
            <PublicHeader />
            {/* Stage 3.9 (Tasks 5/6): reaches every public candidate page (Landing/Login, Registration,
                Forgot/Reset/Set Password) through this single mount point. Also reached by the other
                4 portals' pre-login screens, which share this layout — the component itself skips
                rendering there (see its own staff-path guard). */}
            <AccessibilityToolbar />
            <div className="loginPage">
                {React.cloneElement(this.props.children, { } )}
            </div>
        </div>
        );
    }
}

export default PublicLayout;